module.exports = __webpack_public_path__ + "static/media/marketplace.004dc6dd.svg";